'use client'

import classNames from 'clsx'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import JoinArenaArrow from '@/assets/icons/join-arena-arrow.svg'
import { URLS } from '@/configs/urls'
import { Link } from '@/i18n/routing'
import { useHydratedAuthUi } from '@/lib/react/useHydratedAuthUi'
import { useAuth } from '@/providers/AuthProvider'

import { STADIUM_FANS_IMG } from '../fansLandingContent.constants'
import S from './FansStadiumCta.module.scss'

const FansStadiumCta = () => {
  const t = useTranslations('fansPage.hero')
  const hasHydratedAuthUi = useHydratedAuthUi()
  const { openAuthModal, isAuthenticated } = useAuth()
  const showAuthenticatedCta = hasHydratedAuthUi && isAuthenticated

  return (
    <div className={S.stadiumFansBand}>
      <div className={S.stadiumFansBandInner}>
        <Image
          src={STADIUM_FANS_IMG}
          alt=""
          fill
          sizes="100vw"
          quality={60}
          className={S.stadiumFansImage}
        />
        <div className={S.stadiumFansDarken} aria-hidden />
        <div className={S.stadiumFansGrain} aria-hidden />
        <div className={S.stadiumFansTopBlend} aria-hidden />
        <div className={S.stadiumFansBottomBlend} aria-hidden />
        <div className={S.stadiumFansForeground}>
          <div className={S.stadiumFansCopy}>
            <p className={S.stadiumFansTitle}>
              {showAuthenticatedCta
                ? t('authStadiumFansTitle')
                : t('stadiumFansTitle')}
            </p>
            <div className={S.stadiumFansBody}>
              {showAuthenticatedCta ? (
                <p className={S.stadiumFansBodyLine}>
                  {t('authStadiumFansBody')}
                </p>
              ) : (
                <>
                  <div className={S.stadiumFansBodyDesktop}>
                    <p className={S.stadiumFansBodyLine}>
                      {t('stadiumFansBodyLine1')}
                    </p>
                    <p className={S.stadiumFansBodyLine}>
                      {t('stadiumFansBodyLine2')}
                    </p>
                  </div>
                  <p
                    className={classNames(
                      S.stadiumFansBodyLine,
                      S.stadiumFansBodyLineMobileSingle
                    )}
                  >
                    {t('stadiumFansBodyLine1')} {t('stadiumFansBodyLine2')}
                  </p>
                </>
              )}
            </div>
          </div>
          <div className={S.stadiumFansActions}>
            {showAuthenticatedCta ? (
              <>
                <Link
                  href={URLS.CHALLENGES}
                  className={S.stadiumFansPrimaryBtn}
                >
                  <span className={S.stadiumFansPrimaryBtnText}>
                    {t('stadiumFansGoToTasks')}
                  </span>
                  <JoinArenaArrow
                    className={S.stadiumFansPrimaryBtnIcon}
                    aria-hidden
                  />
                </Link>
                <Link
                  href={URLS.LEADERBOARD_CLUBS}
                  className={S.stadiumFansSecondaryBtn}
                >
                  {t('stadiumFansClubLeaderboard')}
                </Link>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className={S.stadiumFansPrimaryBtn}
                  onClick={() =>
                    openAuthModal('emailSignupEntityChoose', 'landing')
                  }
                >
                  <span className={S.stadiumFansPrimaryBtnText}>
                    {t('stadiumFansCreateAccount')}
                  </span>
                  <JoinArenaArrow
                    className={S.stadiumFansPrimaryBtnIcon}
                    aria-hidden
                  />
                </button>
                <Link
                  href={URLS.LEADERBOARD_CLUBS}
                  className={S.stadiumFansSecondaryBtn}
                >
                  {t('stadiumFansBrowseClubs')}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FansStadiumCta
